import React, { useEffect, useState } from 'react';
import UIContext from './UIStackContext';
export default function UIStack(_a) {
    var children = _a.children;
    var _b = useState([]), stacks = _b[0], setStacks = _b[1];
    var _c = useState({}), reflesh = _c[0], setReflesh = _c[1];
    useEffect(function () {
        if (stacks.length <= 0)
            return;
        console.log('pop');
        stacks.pop();
        setStacks(stacks.concat());
    }, [reflesh]);
    return React.createElement(UIContext.Provider, { value: {
            push: function (page) {
                setStacks(stacks.concat(page));
            },
            pop: function () {
                console.log('callreflesh');
                setReflesh({});
            },
            close: function () {
                setStacks([]);
            }
        } },
        children,
        stacks.map(function (value, index) {
            if (value instanceof Function) {
                console.log('function');
                return value(index === stacks.length - 1);
            }
            else {
                return index === stacks.length - 1 ? value : null;
            }
        }));
}
//# sourceMappingURL=UIStack.js.map